var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_manual",
    transform: "translate(1 0.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1122",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1122",
    transform: "translate(-1 -0.945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_809",
    "data-name": "\\u9577\\u65B9\\u5F62 809",
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_585",
    "data-name": "\\u30D1\\u30B9 585",
    d: "M13.534,4.813A7.4,7.4,0,0,0,11.341,4.5a5.829,5.829,0,0,0-3.447.94A5.829,5.829,0,0,0,4.447,4.5,5.829,5.829,0,0,0,1,5.44v9.182a.337.337,0,0,0,.313.313c.063,0,.094-.031.157-.031a7.649,7.649,0,0,1,2.977-.689,5.829,5.829,0,0,1,3.447.94,7.549,7.549,0,0,1,3.447-.94,6.379,6.379,0,0,1,2.977.658.283.283,0,0,0,.157.031.337.337,0,0,0,.313-.313V5.44A4.275,4.275,0,0,0,13.534,4.813Zm0,8.461a7.283,7.283,0,0,0-2.194-.313,7.549,7.549,0,0,0-3.447.94V6.694a7.549,7.549,0,0,1,3.447-.94,7.283,7.283,0,0,1,2.194.313Z",
    transform: "translate(-1.373 -3.416)",
    fill: "#3182ce"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_813",
    "data-name": "\\u9577\\u65B9\\u5F62 813",
    width: 15,
    height: 15,
    transform: "translate(-1 -0.945)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManual);
export default __webpack_public_path__ + "static/media/icon_manual.9d001fe26ee2823217c21e530f6fce39.svg";
export { ForwardRef as ReactComponent };